/* eslint max-classes-per-file: 0 */

import { VPRPublication as Data, VPRPublicationPart as DataPart } from '@/typings/api/VPRPublications'
import { AxiosRequestConfig } from 'axios'

import { BaseApiAuth } from '@/api/BaseApiAuth'

export class ImportKimsTasksApi extends BaseApiAuth<Data> {
  protected readonly endpoint = 'collector/kims/';

  public importKims(
    pId: Data['lk_publication_id'],
    sId: DataPart['lk_kim_storage_id'] | DataPart['lk_krit_storage_id'],
    config: AxiosRequestConfig = {},
  ) {
    const path = 'import/vpr/'
    const [url] = this.getUrl(path)
    return this.request('POST', url, { data: { publication_id: pId, storage_id: sId }, ...config })
  }

  public getImportedKims(storage_id: DataPart['lk_kim_storage_id'], params?: unknown, config: AxiosRequestConfig = {}) {
    const path = `tasks/${storage_id}/import/storage`
    const [url] = this.getUrl(path)
    return this.request('GET', url, { params, ...config })
  }
}
